// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getBrandingRequestToJson, getBrandingResponseFromJson, getConfigurationRequestToJson, getConfigurationResponseFromJson, getMultiBrandingRequestToJson, getMultiBrandingResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getBranding(request) {
    const raw = await fetchRpc('partner.v1.Whitelabel/GetBranding', getBrandingRequestToJson(request));
    return getBrandingResponseFromJson(raw);
}
export function getBranding$(request, options) {
    return defer(() => getBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function getBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Whitelabel/GetBranding', getBrandingRequestToJson(request), options)
        .pipe(map(resp => getBrandingResponseFromJson(resp)));
}
export async function getMultiBranding(request) {
    const raw = await fetchRpc('partner.v1.Whitelabel/GetMultiBranding', getMultiBrandingRequestToJson(request));
    return getMultiBrandingResponseFromJson(raw);
}
export function getMultiBranding$(request, options) {
    return defer(() => getMultiBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Whitelabel/GetMultiBranding', getMultiBrandingRequestToJson(request), options)
        .pipe(map(resp => getMultiBrandingResponseFromJson(resp)));
}
export async function getConfiguration(request) {
    const raw = await fetchRpc('partner.v1.Whitelabel/GetConfiguration', getConfigurationRequestToJson(request));
    return getConfigurationResponseFromJson(raw);
}
export function getConfiguration$(request, options) {
    return defer(() => getConfigurationWithTransport$(getGlobalTransport(), request, options));
}
export function getConfigurationWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.Whitelabel/GetConfiguration', getConfigurationRequestToJson(request), options)
        .pipe(map(resp => getConfigurationResponseFromJson(resp)));
}
